var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 500,
    viewBox: "0 0 1440 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".mhcls1{fill:#ab262d}.mhcls2{fill:url(#mh-lg)}.mhcls3{fill:url(#mh-lg-2)}.mhcls4{fill:url(#mh-lg-3)}.mhcls5{fill:url(#mh-lg-4)}.mhcls6{fill:url(#mh-lg-5)}.mhcls7{fill:url(#mh-lg-6)}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mh-lg",
    x1: 1105.66,
    y1: 63.16,
    x2: 1141.58,
    y2: -54.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8222e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#c8222e",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c8222e",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c8222e",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c8222e",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#c8222e",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c8222e",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#c8222e",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c8222e",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c8222e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mh-lg-2",
    x1: 668.16,
    y1: 120.88,
    x2: 722.9,
    y2: -38.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8222e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c8222e",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#c8222e",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c8222e",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#c8222e",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c8222e",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c8222e",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c8222e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mh-lg-3",
    x1: 1217.36,
    y1: 358.03,
    x2: 1439.93,
    y2: 683.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8222e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c8222e",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c8222e",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c8222e",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c8222e",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#c8222e",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c8222e",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c8222e",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c8222e",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c8222e",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#c8222e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mh-lg-4",
    x1: 912.11,
    y1: 206.71,
    x2: 1081.23,
    y2: 524.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8222e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#c8222e",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c8222e",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#c8222e",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c8222e",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#c8222e",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c8222e",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c8222e",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#c8222e",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#c8222e",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c8222e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mh-lg-5",
    x1: 360.43,
    y1: 226.88,
    x2: 478.03,
    y2: 415.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c8222e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c8222e",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c8222e",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c8222e",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#c8222e",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c8222e",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#c8222e",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c8222e",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8222e",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8222e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mh-lg-6",
    x1: 196.23,
    y1: 90.31,
    x2: 279.82,
    y2: 254.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#c8222e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c8222e",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c8222e",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c8222e",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c8222e",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#c8222e",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#c8222e",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#c8222e",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c8222e",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c8222e",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8222e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "mhcls1",
    d: "M0 0h1440v500H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mhcls1",
    d: "M0 0h1440v500H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mhcls2",
    d: "M930.67 0c68.12 22.17 134.3 45.46 190.86 68 61.1-23.82 135.63-49.57 197.75-68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mhcls3",
    d: "M831.62 0H317.56C450.43 36 665 108.76 854.2 184.94c74.84-36.53 143.36-67.59 217.86-98C996.23 56 912.12 26.24 831.62 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mhcls4",
    d: "M1440 500V252c-143.29 72.29-286.08 157.09-420.72 248z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mhcls5",
    d: "M1420 0c-337.49 97.83-697.12 293.07-989.75 500h471.63c179.64-118.83 364.55-220.63 538.12-298.91V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mhcls6",
    d: "M322.79 500C472.11 396 646 289.68 809.63 207.87c-71.75-28.71-152-59.9-208-80.1-154 61.34-379.86 179.3-572.09 307.45 46.79 21.44 92.14 42.6 136.86 64.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mhcls7",
    d: "M0 394.14C176.81 284 390.72 175.71 558.52 112.36c-65.2-23.5-149.46-51.67-207.81-69.57A3528.27 3528.27 0 0 0 0 190.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBg);
export default __webpack_public_path__ + "static/media/cardBg.d3415384e6f0a028910d5fc861bcaa5d.svg";
export { ForwardRef as ReactComponent };